import {combineReducers} from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

import * as auth from "../app/redux/Auth/authRedux";
import {queryReducer} from "../app/redux/Query/queryRedux";
import {reviewReducer} from "../app/redux/Review/reviewRedux";
import {tracksReducer} from "../app/redux/Tracks/tracksRedux";
import {trackPageReducer} from "../app/redux/TrackPage/trackPageRedux";
import {mediaItemReducer} from "../app/redux/MediaItemPage/mediaItemRedux";
import {mediaItemsListReducer} from "../app/redux/MediaItemsList/mediaItemsListRedux";
import {settingsReducer} from "../app/redux/Settings/settingsRedux";
import {errorReducer} from "../app/redux/ErrorHandler/errorHandler";
import {routesReducer} from "../app/redux/Routes/routesRedux";

import componentsSlice from "../app/redux_slices/componentsSlice";
import homePageSettingsSlice from "../app/redux/Settings/homePageSlice";
import reviewSlice from "../app/redux/Review/reviewSlice";
import layoutSlice from "../app/redux/Layout/layoutSlice";
// import videoPageSlice from "../app/redux_slices/videoPageSlice";
import contextSlice from "../app/redux_slices/contextSlice";
import authenticationSlice from "../app/redux_slices/authenticationSlice";
import parametersSlice from "../app/redux_slices/parametersSlice";
import userParametersSlice from "../app/redux_slices/userParametersSlice";
import settingsFeaturesSlice from "../app/redux_slices/settingsFeaturesSlice";
import settingsCredentialsSlice from "../app/redux_slices/settingsCredentialsSlice";
import mediaItemsReducer from "../app/redux_slices/mediaItemsSlice";

const appReducer = combineReducers({
    auth: auth.reducer,
    authentication: authenticationSlice,
    context: contextSlice,
    query: queryReducer,
    review: reviewReducer,
    tracks: tracksReducer,
    trackPage: trackPageReducer,
    mediaItemPage: mediaItemReducer,
    mediaItemsList: mediaItemsListReducer,
    settings: settingsReducer,
    error: errorReducer,
    routes: routesReducer,
    components: componentsSlice,
    parameters: parametersSlice,
    settingsFeatures: settingsFeaturesSlice,
    settingsCredentials: settingsCredentialsSlice,
    userParameters: userParametersSlice,
    homepageSettings: homePageSettingsSlice,
    reviewNew: reviewSlice,
    layout: layoutSlice,
    mediaItems: mediaItemsReducer,
    // mediaItemPage: videoPageSlice,
});
export const rootReducer = (state, action) => {
    if (action.type === `CLEAR_STORE`) {
        storage.removeItem("persist:authentication");
        state = undefined;
        // window.location.reload();
    }
    return appReducer(state, action);
};
